import React from "react";
import { useState, useEffect } from "react";
//import Axios from "axios";
import logo from "../img/logo-02.png";
import { Link } from "react-router-dom";
import Loading from "./Loading";
import supabase from "../Supa";

/*
import { sendPasswordResetEmail } from "firebase/auth";
import auth from "../firebase";*/

function ChangePassword() {
  const [userList, setUserList] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase.auth.onAuthStateChange(async (event, session) => {
      if (event == "PASSWORD_RECOVERY") {
        const newPassword = prompt(
          "What would you like your new password to be?"
        );
        const { data, error } = await supabase.auth.updateUser({
          password: newPassword,
        });

        if (data) alert("Password updated successfully!");
        if (error) alert("There was an error updating your password.");
      }
    });
  }, []);

  let reset = async (e) => {
    e.preventDefault();

    try {
      // const { data, error } = await supabase.auth
      // .resetPasswordForEmail(email)

      //  if (error) throw error
      console.log("here");
      //  console.log(email)
      // setToken(data)
      //navigate("/dashboard")
    } catch (error) {
      console.log(error);
    }

    /*
    await sendPasswordResetEmail(auth, email)
      .then(() => {
        alert("Check Email");
      })
      .catch((error) => {
        const errorCode = error.code;
        alert(errorCode);
      });*/
  };

  return (
    <>
      <div>
        <div className="Login-container">
          <div className="Login-left">
            <img
              src={logo}
              className="Login-animation a6"
              style={{ margin: "0 auto 10px", width: "150px" }}
              alt="Login"
            />
            {loading && <Loading />}
            <div className="Login-header">
              <h2 className="Login-animation a1">Reset Your password</h2>
              <p className="Login-animation a2">Will get you Logged in Soon!</p>
            </div>
            <div className="Login-form">
              <input
                type="password"
                className="Login-form-field Login-animation a3"
                name=""
                placeholder="Password"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              {/*   <input type="password" className="Login-form-field Login-animation a4 " name="" placeholder="Password" style={{marginTop:"10px"}} onChange={(e) => {setPassword(e.target.value)}} />*/}
              <div className="Login-animation a5" style={{ margin: "20px" }}>
                <span style={{ fontSize: "12px" }}>
                  {/*<input type="checkbox" id="check" className="Login-animation a5" name="" /><label for="check" style={{paddingLeft: "10px",color: "#afafaf"}}>Remember my password</label> |*/}{" "}
                  <Link to="/" className="">
                    Login{" "}
                  </Link>{" "}
                </span>
              </div>
              <div style={{ textAlign: "end" }}>
                <button className="btn1 btn-default" onClick={reset}>
                  Reset Password
                </button>
              </div>
            </div>
          </div>
          <div id="Loing-right"></div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
